"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEligibleUsersResponseToJSON = exports.GetEligibleUsersResponseFromJSONTyped = exports.GetEligibleUsersResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetEligibleUsersResponseFromJSON(json) {
    return GetEligibleUsersResponseFromJSONTyped(json, false);
}
exports.GetEligibleUsersResponseFromJSON = GetEligibleUsersResponseFromJSON;
function GetEligibleUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eligibleUsers': !(0, runtime_1.exists)(json, 'eligibleUsers') ? undefined : (json['eligibleUsers'].map(_1.EligibleUserFromJSON)),
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
        'page': !(0, runtime_1.exists)(json, 'page') ? undefined : json['page'],
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
    };
}
exports.GetEligibleUsersResponseFromJSONTyped = GetEligibleUsersResponseFromJSONTyped;
function GetEligibleUsersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eligibleUsers': value.eligibleUsers === undefined ? undefined : (value.eligibleUsers.map(_1.EligibleUserToJSON)),
        'totalCount': value.totalCount,
        'page': value.page,
        'limit': value.limit,
    };
}
exports.GetEligibleUsersResponseToJSON = GetEligibleUsersResponseToJSON;
